import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';
import { RodeoEvent } from 'model/rodeoEvent';

@Component({
    selector: 'stallion-logs',
    templateUrl: 'stallion-logs.html'
})
export class StallionLogsPage {
    logs: any[];
    rodeoEvent: RodeoEvent = null;

    constructor(navParams: NavParams, private viewController: ViewController) {
        this.rodeoEvent = navParams.get('rodeoEvent');
        this.logs = navParams.get('logs');
    }

    cancel() {
        this.viewController.dismiss();
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/organization/stallions/stallion-logs.ts